<div class="w-100" [ngClass]="noSuchZip ? 'noZip' : ''">
    <input type="text" [ngModel]="zip" [ngClass]="options.classes" (keyup)="search($event)" placeholder="{{ 'Standard.Zipcode' | translate }}">
</div>
